<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="14" v-show="!isSync()">
                <el-card>
                    <el-row>
                        <el-col style="padding: 10px 0 20px">
                            <!-- <span>供应商档案列表</span> -->
                            <el-button
                                type="danger"
                                size="mini"
                                icon="el-icon-delete"
                                class="pull-right"
                                @click="deleteBatch"
                                >批量删除</el-button
                            >
                            <el-button
                                class="pull-right right-10"
                                icon="el-icon-upload"
                                type="primary"
                                size="mini"
                                @click="CheckBasicInfo()"
                                >检测财务系统编码</el-button
                            >
                            <el-button
                                class="pull-right"
                                icon="el-icon-upload"
                                type="primary"
                                size="mini"
                                @click="importFile()"
                                >批量导入</el-button
                            >
                            <el-button
                                class="pull-right"
                                icon="el-icon-download"
                                type="primary"
                                size="mini"
                                @click="downloadFile('餐饮供应商档案')"
                                >模板下载</el-button
                            >
                            <el-button
                                class="pull-right"
                                icon="el-icon-download"
                                type="primary"
                                size="mini"
                                @click="downLoadExcel()"
                                >导出Excel</el-button
                            >
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addRow"
                                >新增</el-button
                            >
                            <div class="pull-right">
                                <el-input
                                    placeholder="请输入编码,名称"
                                    prefix-icon="el-icon-search"
                                    v-model="FinQueryParams.archiveFilter"
                                    size="mini"
                                ></el-input>
                            </div>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="FinTableData"
                        size="mini"
                        style="width: 100%"
                        border
                        ref="FinTableData"
                        @select="tableSelectHandler"
                        @select-all="tableSelectAllHandler"
                        :row-key="getRowKeys"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            width="55"
                            :reserve-selection="true"
                        ></el-table-column>
                        <el-table-column label="操作" width="160">
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="top">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="editRow(scope.row)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="top">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="deleteRow(scope.row._id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="supplierCode" label="供应商编码">
                            <template slot-scope="scope">{{
                                scope.row.supplierCode
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="supplierName" label="供应商名称">
                            <template slot-scope="scope">{{
                                scope.row.supplierName
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="csupplierCode"
                            label="餐饮7供应商编码"
                        >
                            <template slot-scope="scope">{{
                                scope.row.posSupplierCode
                            }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="GetFinDataUrl"
                        :GetData="InitFinData"
                        :queryParam="FinQueryParams"
                        :isInit="true"
                        :errorFunc="CloseError"
                        size="mini"
                    ></pagerBar>
                </el-card>
            </el-col>
            <el-col :span="throughAll">
                <el-card>
                    <el-row>
                        <el-col style="padding: 10px 0 20px">
                            <span>餐饮7源数据</span>
                            <div class="pull-right">
                                <el-input
                                    placeholder="请输入编码,名称"
                                    prefix-icon="el-icon-search"
                                    v-model="QueryParams.filter"
                                    size="mini"
                                ></el-input>
                            </div>
                            <el-button
                                class="pull-right right-10"
                                icon="el-icon-upload"
                                type="primary"
                                size="mini"
                                v-show="isSync()"
                                @click="SyncBasicInfo()"
                                >同步</el-button
                            >
                        </el-col>
                    </el-row>

                    <el-table
                        :data="CloudTableData"
                        size="mini"
                        style="width: 100%"
                        border
                    >
                        <el-table-column label="供应商编码">
                            <template slot-scope="scope">{{
                                scope.row.id
                            }}</template>
                        </el-table-column>
                        <el-table-column label="供应商名称">
                            <template slot-scope="scope">{{
                                scope.row.name
                            }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="cloundApiUrl"
                        :apiURL="GetCloudOrderUrl"
                        :GetData="InitCloudData"
                        :queryParam="QueryParams"
                        :isInit="true"
                        :errorFunc="CloseError"
                        size="mini"
                    ></pagerBar>
                    <el-table
                        id="PosSupplierData"
                        ref="detail"
                        size="mini"
                        hidden
                        :data="basicPosSupplierData"
                    >
                        <el-table-column
                            prop="supplierCode"
                            label="供应商编码"
                        ></el-table-column>
                        <el-table-column
                            prop="supplierName"
                            label="供应商名称"
                        ></el-table-column>
                        <el-table-column
                            prop="posSupplierCode"
                            label="餐饮7供应商编码"
                        ></el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <!-- 批量导入Dialog开始 -->
        <uploadTemp
            :apiURL="fileUploadUrl"
            ref="refFileUpload"
            :Refresh="Refresh"
            :OtherParams="{ brandId: QueryParams.BrandID }"
        ></uploadTemp>
        <!-- 批量导入Dialog结束 -->
        <!-- 数据新增Dialog开始-->
        <el-dialog
            v-el-drag-dialog
            :title="xtitle"
            :visible.sync="formVisible"
            width="35%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                :label-position="labelPosition"
                label-width="130px"
                :model="RowModel"
                :rules="rules"
                ref="refMaterielForm"
            >
                <el-form-item label="供应商编码" prop="supplierCode">
                    <el-input
                        v-model="RowModel.supplierCode"
                        placeholder="请输入财务系统供应商编码"
                    ></el-input>
                </el-form-item>
                <el-form-item label="供应商名称" prop="supplierName">
                    <el-input
                        v-model="RowModel.supplierName"
                        placeholder="请输入财务系统供应商名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="餐饮7供应商编码" prop="posSupplierCode">
                    <el-input
                        v-model="RowModel.posSupplierCode"
                        placeholder="请输入餐饮7供应商编码"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="info"
                    size="medium"
                    @click="formVisible = false"
                    icon="el-icon-close"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    size="medium"
                    @click="saveRow"
                    icon="el-icon-check"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
        <!-- 数据新增Dialog结束 -->
        <el-dialog
            title="错误详情"
            size="medium"
            :visible.sync="sublistShow"
            width="520px"
            class="errorDialog"
        >
            <div class="form-horizontal form-horizontal2">
                <el-table
                    :data="ErrorList"
                    size="mini"
                    style="width: 100%"
                    border
                >
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="code" label="编码"></el-table-column>
                    <el-table-column label="基础档案类别"
                        >餐饮供应商档案</el-table-column
                    >
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
import uploadTemp from '@/views/batchUploadTemp/uploadTemp'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
    components: {
        pagerBar,
        uploadTemp
    },
    data() {
        return {
            basicPosSupplierData: [],

            //财务基础档案
            FinTableData: [],
            //云供应链基础档案
            CloudTableData: [],
            GetCloudOrderUrl: config.BASE_Middle_API + 'PosShop/GetAll',
            GetFinDataUrl: config.BASE_Middle_API + 'PosSupplier/GetAll',
            ApiUrl: config.BASE_Middle_API + 'PosSupplier',
            fileUploadUrl: config.BASE_Middle_API + 'PosSupplier/UploadFiles',
            downLoadUrl: config.BASE_Middle_API + 'PosSupplier/DownloadFiles',
            downLoadExcelUrl:
                config.BASE_Middle_API + 'PosSupplier/ExcelOutPut',
            QueryParams: {
                FieldName: 'possupplier',
                BrandID: this.$route.query.brandId
            },
            FinQueryParams: {
                BrandID: this.$route.query.brandId
            },
            basicDataListUrl: config.BASE_Middle_API + 'BasicDataList', //基础档案
            ErrorList: [],
            sublistShow: false, //子表默认隐藏
            syncModeSetting: this.$route.query.syncmode,
            throughAll: '',
            RowModel: {
                supplierCode: '',
                supplierName: '',
                posSupplierCode: ''
            },
            labelPosition: 'left',
            handleClose(d) {
                d()
            },
            xtitle: '',
            formVisible: false,
            rules: {
                supplierCode: [
                    {
                        required: true,
                        message: '请输入财务系统供应商编码',
                        trigger: 'blur'
                    }
                ],
                supplierName: [
                    {
                        required: true,
                        message: '请输入财务系统供应商名称',
                        trigger: 'blur'
                    }
                ],
                posSupplierCode: [
                    {
                        required: true,
                        message: '请输入餐饮7供应商编码',
                        trigger: 'blur'
                    }
                ]
            },
            selOrder: [],
            selOrderIds: [],
            deleteUrl: config.BASE_Middle_API + 'PosShop/ChangeBasicInfoRecords'
        }
    },
    props: {
        openloading: {
            type: Function,
            required: true
        },
        closeloading: {
            type: Function,
            required: true
        }
    },
    methods: {
        getRowKeys(row) {
            return row._id
        },
        handleSelectionChange(val) {
            // this.multipeleSelectedIds = val;
            const _this = this
            let b = false
            _this.selOrder.forEach((item) => {
                if (item.key == _this.$refs.refPagerBar.currentPage) {
                    b = true
                    item.value = val
                }
            })
            if (!b) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            }
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.FinTableData.find(
                            (tableRow) => tableRow._id === row._id
                        )
                        this.$refs.FinTableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.FinTableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item._id === row._id)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (!_this.selOrder.find((item) => item._id === key._id)) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item._id !== row._id
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.FinTableData)
            } else {
                this.removeRows(this.FinTableData)
            }
        },
        deleteBatch() {
            const _this = this
            _this.selOrderIds = []
            _this.selOrder.forEach((item) => {
                if (item.value != null && item.value.length > 0) {
                    item.value.forEach((v) => {
                        _this.selOrderIds.push(v._id)
                    })
                }
            })
            if (_this.selOrderIds.length == 0) {
                this.$notify({
                    title: '提示',
                    message: '请先勾选需要删除的单据',
                    type: 'error',
                    position: 'bottom-right'
                })
                return
            }
            AjaxHelper.post(_this.deleteUrl, {
                brandID: _this.QueryParams.BrandID,
                FieldName: 'possupplier',
                orderIds: _this.selOrderIds
            })
                .then(function (r) {
                    if (r.success) {
                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        _this.$refs.FinTableData.clearSelection()
                        _this.$refs.refPagerBar.Refresh()
                    }
                })
                .catch((e) => {
                    _this.$message({
                        type: 'info',
                        message: e.message
                    })
                })
        },
        downExcel() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#PosSupplierData').removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#PosSupplierData').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#PosSupplierData'),
                    xlsxParam
                )
            }
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                const fileName = '餐饮供应商档案.xlsx' //下载文件名称
                FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    fileName
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }
            return wbout
        },
        downLoadExcel() {
            const _this = this
            AjaxHelper.post(this.downLoadExcelUrl, this.FinQueryParams)
                .then((res) => {
                    if (res.success) {
                        _this.basicPosSupplierData = res.result
                        if (_this.basicPosSupplierData.length <= 0) {
                            _this.$notify({
                                title: '提示',
                                message: '当前无可导出的数据',
                                type: 'error',
                                position: 'bottom-right'
                            })
                            return false
                        } else {
                            _this.$nextTick(function () {
                                _this.downExcel()
                            })
                        }
                    }
                })
                .catch(function (error) {})
        },
        isSync() {
            const _this = this
            if (_this.syncModeSetting == '1') {
                _this.throughAll = 24
                return true
            } else {
                _this.throughAll = 10
                return false
            }
        },
        CheckBasicInfo() {
            const _this = this
            _this.openloading()
            AjaxHelper.post(
                _this.basicDataListUrl + '/CheckBasicInfoInFin',
                _this.QueryParams
            )
                .then(function (response) {
                    if (response.result.length > 0) {
                        _this.sublistShow = true
                        _this.ErrorList = response.result
                    } else {
                        _this.$notify({
                            title: '检查成功',
                            message: '无错误信息',
                            type: 'success',
                            position: 'bottom-right'
                        })
                    }
                    _this.closeloading()
                    _this.RefreshSourceData()
                })
                .catch(function (error) {
                    _this.closeloading()
                })
        },
        RefreshSourceData() {
            this.$refs.cloundApiUrl.Refresh()
        },
        SyncBasicInfo() {
            const _this = this
            _this.openloading()
            AjaxHelper.post(
                _this.basicDataListUrl + '/SyncBasicInfoToFin',
                _this.QueryParams
            )
                .then(function (response) {
                    if (response.result.isSuccess) {
                        _this.$notify({
                            title: '成功',
                            message: response.result.SuccessMsg,
                            type: 'success',
                            position: 'bottom-right'
                        })
                    } else {
                        _this.$notify({
                            title: '失败',
                            message: response.result.errorMsg,
                            type: 'error',
                            position: 'bottom-right'
                        })
                    }
                    _this.closeloading()
                    _this.RefreshSourceData()
                })
                .catch(function (error) {
                    _this.closeloading()
                })
        },
        InitCloudData(data) {
            this.CloudTableData = data
            this.closeloading()
        },
        InitFinData(data) {
            this.FinTableData = data
            this.closeloading()
        },
        CloseError() {
            this.closeloading()
        },

        Refresh() {
            this.$refs.refPagerBar.Refresh()
        },
        initModel() {
            const _this = this
            if (_this.$refs['refMaterielForm']) {
                _this.$refs['refMaterielForm'].resetFields()
                _this.RowModel = {
                    id: 0
                }
            }
        },

        addRow() {
            this.initModel()
            this.xtitle = '新增供应商对照'
            this.formVisible = true
            this.operation = 'Add'
        },
        editRow(row) {
            const _this = this
            _this.initModel()
            _this.xtitle = '编辑供应商对照'
            _this.operation = 'Edit'
            _this.RowModel = Object.assign({}, row)
            _this.formVisible = true
        },

        saveRow() {
            //提交保存
            const _this = this
            this.$refs['refMaterielForm'].validate((valid) => {
                if (valid) {
                    let postUrl = ''
                    if (_this.operation == 'Add') {
                        postUrl = '/Add'
                    } else {
                        postUrl = '/Edit'
                    }
                    _this.RowModel.brandId = _this.QueryParams.BrandID
                    _this.RowModel.tempId = _this.RowModel._id
                    AjaxHelper.post(_this.ApiUrl + postUrl, _this.RowModel)
                        .then(function (response) {
                            if (response.success) {
                                _this.$notify({
                                    title: '成功',
                                    message: '操作成功',
                                    type: 'success',
                                    position: 'bottom-right'
                                })
                                _this.formVisible = false
                                _this.initModel()
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {})
                }
            })
        },
        deleteRow(id) {
            const _this = this
            this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this.RowModel.brandId = _this.QueryParams.BrandID
                    _this.RowModel.tempId = id
                    AjaxHelper.delete(_this.ApiUrl + '/Delete', _this.RowModel)
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {})
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        downloadFile(name) {
            let requestConfig = {
                headers: {
                    'Content-Type': 'application/json;application/octet-stream'
                }
            }
            AjaxHelper.post(this.downLoadUrl, requestConfig, {
                responseType: 'blob'
            }).then((res) => {
                // 处理返回的文件流
                const content = res
                const blob = new Blob([content])
                var date =
                    new Date().getFullYear() +
                    '' +
                    (new Date().getMonth() + 1) +
                    '' +
                    new Date().getDate()
                const fileName = date + name + '.xlsx'
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            })
        },
        importFile() {
            this.$refs.refFileUpload.open()
        }
    }
}
</script>

<style>
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>
